export default __webpack_public_path__ + "static/media/american_express.153cfc92.svg";